import { JOIN_WINDOW_LEAD_MINUTES } from '@proctoring/shared';
const MINUTE_MS = 60_000;
export const JOIN_WINDOW_LEAD_MS = JOIN_WINDOW_LEAD_MINUTES * MINUTE_MS;
/**
 * Mirrors the API's join-window policy (`apps/api/src/services/interview-service.ts`).
 *
 * Duplicated deliberately and only ever to *disable* UI: the API remains the authority and
 * re-checks on every join, so a clock skew here can gray a button out early but can never
 * let someone into a room the server would refuse.
 */
export function joinWindowStatus(interview, now) {
    if (interview.state === 'completed')
        return { state: 'closed', reason: 'completed' };
    if (interview.state === 'cancelled')
        return { state: 'closed', reason: 'cancelled' };
    const opensAt = new Date(new Date(interview.scheduledAt).getTime() - JOIN_WINDOW_LEAD_MS);
    const msUntilOpen = opensAt.getTime() - now.getTime();
    if (msUntilOpen > 0)
        return { state: 'waiting', opensAt, msUntilOpen };
    return { state: 'open', opensAt };
}
/**
 * Formats a countdown as `d h m s`, dropping leading units that are zero.
 *
 * Seconds are always shown so the last minute visibly ticks — a countdown that sits on
 * "1m" for sixty seconds reads as broken.
 */
export function formatCountdown(ms) {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const days = Math.floor(total / 86_400);
    const hours = Math.floor((total % 86_400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const parts = [];
    if (days > 0)
        parts.push(`${days}d`);
    if (days > 0 || hours > 0)
        parts.push(`${hours}h`);
    if (days > 0 || hours > 0 || minutes > 0)
        parts.push(`${minutes}m`);
    parts.push(`${seconds}s`);
    return parts.join(' ');
}
//# sourceMappingURL=join-window.js.map